import React, { useEffect, useState, memo } from 'react';
import { Check, Star, Shield, Clock, BookOpen, Gift, AlertTriangle, ArrowRight, XCircle, ThumbsUp, MapPin, ChevronDown } from 'lucide-react';
const BUYERS = [{
  name: 'Juan M.',
  city: 'Córdoba'
}, {
  name: 'Marcelo T.',
  city: 'CABA'
}, {
  name: 'Gustavo R.',
  city: 'Rosario'
}, {
  name: 'Alejandro P.',
  city: 'Mendoza'
}, {
  name: 'Hernán D.',
  city: 'Neuquén'
}, {
  name: 'Pablo S.',
  city: 'La Plata'
}, {
  name: 'Diego F.',
  city: 'Tandil'
}, {
  name: 'Carlos B.',
  city: 'Mar del Plata'
}, {
  name: 'Roberto A.',
  city: 'Bahía Blanca'
}, {
  name: 'Martín L.',
  city: 'Santa Fe'
}];
export function SalesPage() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  const [showToast, setShowToast] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  const [selectedPack, setSelectedPack] = useState<'esencial' | 'premium'>('premium');
  // Countdown timer logic
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  // Pop-up toast logic
  useEffect(() => {
    const toastInterval = setInterval(() => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000); // Hide after 5 seconds
    }, 25000); // Show every 25 seconds
    return () => clearInterval(toastInterval);
  }, []);
  const handleScrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-parchment-100 font-sans text-charcoal-800" data-id="element-2">
      {/* FAKE PURCHASE POPUP */}
      <div className={`fixed bottom-4 left-4 z-50 bg-white border-l-4 border-green-500 shadow-xl rounded-r-lg p-4 max-w-sm transition-all duration-500 transform ${showToast ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-3">
        <div className="flex items-start gap-3" data-id="element-4">
          <div className="bg-green-100 p-2 rounded-full mt-1" data-id="element-5">
            <Check className="w-4 h-4 text-green-600" data-id="element-6" />
          </div>
          <div data-id="element-7">
            <p className="text-sm font-medium text-charcoal-900" data-id="element-8">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-charcoal-500 mt-1" data-id="element-9">
              Acaba de comprar La Enciclopedia Argentina™
            </p>
            <p className="text-xs text-charcoal-400 mt-1 flex items-center gap-1" data-id="element-10">
              <Clock className="w-3 h-3" data-id="element-11" /> Hace unos minutos
            </p>
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="pt-3 pb-6 px-3 md:pt-12 md:pb-20 md:px-8 max-w-5xl mx-auto text-center" data-id="element-12">
        <div className="inline-flex items-center gap-1.5 md:gap-2 bg-parchment-300 text-charcoal-700 px-2.5 py-1 md:px-4 md:py-2 rounded-full text-[10px] md:text-sm font-medium mb-2 md:mb-8" data-id="element-13">
          <span className="flex items-center gap-1" data-id="element-14">
            <Check className="w-3 h-3 md:w-4 md:h-4 text-green-600" data-id="element-15" /> +4.500
            alumnos
          </span>
          <span className="text-charcoal-400" data-id="element-16">|</span>
          <span className="flex items-center gap-1" data-id="element-17">
            <Star className="w-3 h-3 md:w-4 md:h-4 text-gold-500 fill-gold-500" data-id="element-18" />{' '}
            4.9/5
          </span>
          <span className="text-charcoal-400 hidden md:inline" data-id="element-19">|</span>
          <span className="hidden md:flex items-center gap-1" data-id="element-20">
            <Shield className="w-4 h-4 text-charcoal-500" data-id="element-21" /> Garantía 7 días
          </span>
          <span className="text-charcoal-400 hidden md:inline" data-id="element-22">|</span>
          <span className="hidden md:flex items-center gap-1" data-id="element-23">
            <Clock className="w-4 h-4 text-charcoal-500" data-id="element-24" /> Acceso inmediato
          </span>
        </div>

        <h1 className="font-serif text-xl md:text-6xl font-black text-charcoal-900 leading-tight mb-1.5 md:mb-6" data-id="element-25">
          Hacé charcutería artesanal{' '}
          <span className="text-burgundy-800" data-id="element-26">argentina de verdad.</span>
        </h1>

        <p className="text-xs md:text-2xl text-charcoal-600 mb-1 md:mb-4 max-w-3xl mx-auto font-medium" data-id="element-27">
          El salame, la bondiola, el paté y el jamón que siempre quisiste hacer.
        </p>
        <p className="text-[11px] md:text-xl text-charcoal-500 mb-2 md:mb-10 max-w-2xl mx-auto leading-snug" data-id="element-28">
          Tanto si nunca embutiste nada como si ya tiraste lotes y querés
          entender por qué.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/eBVpYjKLeEL6HzEYjiD6ba/EFBCAC23-7E14-4370-AE10-939A6E55BBD9.png" alt="Charcutería Artesanal Argentina — 6 Tomos, +100 Recetas, 12 Bonos" className="w-auto max-h-72 md:max-h-[32rem] mx-auto object-contain mb-2 md:mb-10 cursor-pointer hover:opacity-95 transition-opacity drop-shadow-2xl" onClick={handleScrollToCompra} data-id="element-29" />

        {/* QUICK INFO SNAPSHOT - For impulsive buyers */}
        <div className="max-w-3xl mx-auto mb-2 md:mb-8 bg-white border border-charcoal-900 md:border-2 rounded-lg md:rounded-2xl shadow md:shadow-xl overflow-hidden" data-id="element-30">
          <div className="bg-charcoal-900 text-white text-center py-1 md:py-3 px-2 md:px-4" data-id="element-31">
            <p className="text-[10px] md:text-base font-bold uppercase tracking-wider flex items-center justify-center gap-1 md:gap-2" data-id="element-32">
              <Star className="w-2.5 h-2.5 md:w-4 md:h-4 fill-gold-400 text-gold-400" data-id="element-33" />{' '}
              EN UN VISTAZO · LO QUE TE LLEVÁS HOY{' '}
              <Star className="w-2.5 h-2.5 md:w-4 md:h-4 fill-gold-400 text-gold-400" data-id="element-34" />
            </p>
          </div>
          <div className="p-2 md:p-8" data-id="element-35">
            <div className="grid grid-cols-2 md:grid-cols-2 gap-1.5 md:gap-4 mb-2 md:mb-6 text-left" data-id="element-36">
              <div className="flex items-start gap-1 md:gap-3" data-id="element-37">
                <BookOpen className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-38" />
                <div data-id="element-39">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-40">
                    6 Tomos completos
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-41">
                    400+ páginas argentinas
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-42">
                <Gift className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-43" />
                <div data-id="element-44">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-45">
                    12 Bonos GRATIS hoy
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-46">
                    Calculadora y protocolos
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-47">
                <Check className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-48" />
                <div data-id="element-49">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-50">
                    100+ Recetas
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-51">
                    Con dosis exactas
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-52">
                <Clock className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-53" />
                <div data-id="element-54">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-55">
                    Acceso de por vida
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-56">
                    Descargá apenas pagás
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-57">
                <Shield className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-58" />
                <div data-id="element-59">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-60">
                    Garantía 7 días
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-61">
                    Devolución 100%
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-62">
                <ThumbsUp className="w-3 h-3 md:w-6 md:h-6 text-gold-600 shrink-0 mt-0.5" data-id="element-63" />
                <div data-id="element-64">
                  <p className="font-bold text-charcoal-900 text-[10px] md:text-base leading-tight" data-id="element-65">
                    100% Argentino
                  </p>
                  <p className="text-[9px] md:text-sm text-charcoal-600 leading-tight" data-id="element-66">
                    Cortes de acá
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-parchment-300 pt-1.5 md:pt-5 flex flex-row md:flex-row items-center justify-center gap-1.5 md:gap-6 flex-wrap" data-id="element-67">
              <div className="flex items-center gap-1.5 md:gap-3" data-id="element-68">
                <span className="text-charcoal-400 line-through text-xs md:text-xl" data-id="element-69">
                  $39.990
                </span>
                <span className="text-lg md:text-4xl font-black text-burgundy-800" data-id="element-70">
                  $15.990
                </span>
                <span className="bg-gold-300 text-charcoal-900 text-[9px] md:text-xs font-bold px-1.5 py-0.5 md:px-2 md:py-1 rounded uppercase" data-id="element-71">
                  60% OFF
                </span>
              </div>
              <span className="text-[9px] md:text-sm text-charcoal-500" data-id="element-72">
                · Mercado Pago
              </span>
            </div>
          </div>
        </div>

        <button onClick={handleScrollToCompra} className="bg-burgundy-800 hover:bg-burgundy-900 text-white text-sm md:text-2xl font-bold py-2.5 px-4 md:py-5 md:px-10 rounded-lg md:rounded-xl shadow-[0_8px_30px_rgb(122,31,36,0.3)] hover:shadow-[0_8px_30px_rgb(122,31,36,0.5)] transform hover:-translate-y-1 transition-all flex items-center justify-center gap-2 md:gap-3 mx-auto w-full md:w-auto" data-id="element-73">
          QUIERO MI MEGA PACK CHARCUTERÍA AHORA{' '}
          <ArrowRight className="w-4 h-4 md:w-6 md:h-6" data-id="element-74" />
        </button>
      </section>

      {/* PAIN POINTS */}
      <section className="bg-charcoal-900 text-parchment-100 py-20 px-4 md:px-8 border-y-4 border-gold-600" data-id="element-75">
        <div className="max-w-5xl mx-auto" data-id="element-76">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-77">
            ¿TE SUENA ALGUNA DE ESTAS?
          </h2>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-78">
            <div className="bg-charcoal-800 p-8 rounded-2xl border border-charcoal-700" data-id="element-79">
              <h3 className="text-2xl font-bold mb-6 text-gold-400 flex items-center gap-3" data-id="element-80">
                <AlertTriangle className="w-6 h-6" data-id="element-81" /> Si nunca lo hiciste:
              </h3>
              <ul className="space-y-4" data-id="element-82">
                <li className="flex items-start gap-3" data-id="element-83">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-84" />
                  <span className="text-lg" data-id="element-85">
                    Te fascina la idea pero no sabés por dónde empezar sin
                    arruinar carne cara
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-86">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-87" />
                  <span className="text-lg" data-id="element-88">
                    Encontrás información pero toda es de España o Italia y los
                    cortes no existen acá
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-89">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-90" />
                  <span className="text-lg" data-id="element-91">
                    No entendés si la sal de cura es peligrosa, cuánta se usa o
                    dónde se consigue
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-92">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-93" />
                  <span className="text-lg" data-id="element-94">
                    Querés hacerlo bien desde el primer intento, no después de
                    tres lotes tirados
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-charcoal-800 p-8 rounded-2xl border border-charcoal-700" data-id="element-95">
              <h3 className="text-2xl font-bold mb-6 text-gold-400 flex items-center gap-3" data-id="element-96">
                <AlertTriangle className="w-6 h-6" data-id="element-97" /> Si ya lo intentaste:
              </h3>
              <ul className="space-y-4" data-id="element-98">
                <li className="flex items-start gap-3" data-id="element-99">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-100" />
                  <span className="text-lg" data-id="element-101">
                    Seguiste la receta al pie de la letra y algo salió mal igual
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-102">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-103" />
                  <span className="text-lg" data-id="element-104">
                    A veces queda bien y a veces no, y nunca sabés exactamente
                    por qué
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-105">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-106" />
                  <span className="text-lg" data-id="element-107">
                    Tiraste carne cara porque el lote falló y no entendiste en
                    qué paso
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-108">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-109" />
                  <span className="text-lg" data-id="element-110">
                    Tenés técnica pero te falta el sistema que haga los
                    resultados consistentes
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-111">
            <p className="text-xl md:text-2xl font-medium mb-4" data-id="element-112">
              Los dos están en el mismo lugar.
            </p>
            <p className="text-lg text-charcoal-400 mb-8" data-id="element-113">
              Uno está antes del primer intento. El otro está después de varios.
            </p>
            <p className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-114">
              Pero los dos necesitan lo mismo:
            </p>
            <p className="text-lg md:text-xl text-parchment-200 mb-10 leading-relaxed" data-id="element-115">
              Un sistema completo, argentino, con dosis exactas y proceso real
              explicado paso a paso. No recetas sueltas de internet. No videos
              que se contradicen. No información de otro país que no aplica acá.
            </p>
            <p className="text-2xl font-serif text-gold-400 font-bold mb-10" data-id="element-116">
              Eso es exactamente lo que construimos.
            </p>

            <button onClick={handleScrollToCompra} className="bg-burgundy-800 hover:bg-burgundy-700 text-white text-xl font-bold py-4 px-8 rounded-xl shadow-lg transform hover:-translate-y-1 transition-all flex items-center justify-center gap-3 mx-auto w-full md:w-auto" data-id="element-117">
              QUIERO EL SISTEMA COMPLETO <ArrowRight className="w-6 h-6" data-id="element-118" />
            </button>
          </div>
        </div>
      </section>

      {/* STORY SECTION */}
      <section className="py-20 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-119">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-charcoal-900 mb-10 text-center" data-id="element-120">
          LA HISTORIA QUE CONOCÉS
        </h2>

        <div className="prose prose-lg md:prose-xl text-charcoal-700 mx-auto space-y-6" data-id="element-121">
          <p data-id="element-122">
            Es sábado a la mañana. Estás en la carnicería mirando una paleta de
            cerdo de primera calidad.
          </p>
          <p data-id="element-123">La comprás. Llegás a casa. Abrís YouTube.</p>
          <p data-id="element-124">
            <strong data-id="element-125">Primer video:</strong> receta española con "aguja" y
            "secreto ibérico". Cortes que acá no existen con esos nombres.
          </p>
          <p data-id="element-126">
            <strong data-id="element-127">Segundo video:</strong> receta italiana con sal de cura en
            dosis que no coinciden con el tercer video. El tercer video dice que
            el segundo está equivocado y que podés envenenar a alguien si te
            equivocás con los nitritos.
          </p>
          <p data-id="element-128">
            <strong data-id="element-129">Cuarto video:</strong> un argentino que explica bien pero en
            el comentario 47 alguien dice que la temperatura que recomienda es
            incorrecta y se arma una discusión de 200 respuestas sin conclusión.
          </p>
          <p data-id="element-130">
            Cerrás todo. Mirás la paleta. Improvisás con lo que te pareció más
            razonable de los cuatro videos.
          </p>
          <p data-id="element-131">Treinta días después abrís el secadero.</p>
          <p className="font-bold text-2xl text-burgundy-800" data-id="element-132">
            Algo no está bien.
          </p>
          <p data-id="element-133">
            No sabés exactamente qué. No sabés exactamente en qué paso falló.
            Solo sabés que tiraste $8.000 pesos en carne, un mes de espera y las
            ganas de volver a intentarlo pronto.
          </p>
          <p data-id="element-134">
            Eso no es falta de talento. No es mala suerte. No es que la
            charcutería artesanal sea demasiado difícil para hacerla en casa.
          </p>
          <p className="font-bold text-xl text-charcoal-900 border-l-4 border-gold-600 pl-6 py-2 bg-parchment-200" data-id="element-135">
            Es que la información que existe en internet sobre charcutería
            artesanal argentina está fragmentada, es contradictoria y en su
            mayoría no está pensada para los cortes, los ingredientes y el
            mercado de acá.
          </p>
          <p className="text-2xl font-serif font-bold text-center mt-12" data-id="element-136">
            Nunca tuviste un sistema. Hasta hoy.
          </p>
        </div>
      </section>

      {/* PRODUCT INTRO */}
      <section className="bg-parchment-200 py-20 px-4 md:px-8 border-y border-parchment-400" data-id="element-137">
        <div className="max-w-4xl mx-auto text-center" data-id="element-138">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-charcoal-900 mb-8" data-id="element-139">
            QUÉ ES LA ENCICLOPEDIA ARGENTINA
          </h2>
          <p className="text-xl text-charcoal-700 mb-8" data-id="element-140">
            No es un curso. No es una colección de recetas. No es un PDF con
            información de Google traducida al español.
          </p>
          <p className="text-2xl font-bold text-burgundy-800 mb-10" data-id="element-141">
            Es el sistema completo de charcutería artesanal más completo pensado
            específicamente para Argentina.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-12" data-id="element-142">
            <div className="bg-white px-6 py-3 rounded-lg shadow-sm font-bold text-charcoal-800 flex items-center gap-2" data-id="element-143">
              <BookOpen className="w-5 h-5 text-gold-600" data-id="element-144" /> 6 tomos organizados
            </div>
            <div className="bg-white px-6 py-3 rounded-lg shadow-sm font-bold text-charcoal-800 flex items-center gap-2" data-id="element-145">
              <Gift className="w-5 h-5 text-gold-600" data-id="element-146" /> 12 bonos especializados
            </div>
            <div className="bg-white px-6 py-3 rounded-lg shadow-sm font-bold text-charcoal-800 flex items-center gap-2" data-id="element-147">
              <BookOpen className="w-5 h-5 text-gold-600" data-id="element-148" /> 400+ páginas
            </div>
            <div className="bg-white px-6 py-3 rounded-lg shadow-sm font-bold text-charcoal-800 flex items-center gap-2" data-id="element-149">
              <Check className="w-5 h-5 text-gold-600" data-id="element-150" /> 100+ recetas completas
            </div>
          </div>

          <div className="text-lg text-charcoal-700 space-y-6 text-left max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-md" data-id="element-151">
            <p data-id="element-152">
              Con las dosis exactas calculadas para los ingredientes que
              conseguís en cualquier carnicería o casa de insumos argentina. Con
              los nombres de los cortes que le pedís a tu carnicero de siempre.
              Con los protocolos de seguridad que te dan la certeza de que lo
              que estás haciendo es seguro para vos y para tu familia.
            </p>
            <p data-id="element-153">
              Cada tomo cubre una categoría completa de productos. Cada receta
              tiene sus dosis exactas. Cada proceso tiene su protocolo de
              seguridad. Cada etapa tiene su checklist de verificación.
            </p>
            <p className="font-bold text-xl text-center text-charcoal-900 pt-4 border-t border-parchment-300" data-id="element-154">
              El resultado es predecible porque el proceso es claro.
            </p>
          </div>
        </div>
      </section>

      {/* TOMOS SECTION */}
      <section className="py-20 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-155">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-center text-stone-900 mb-16" data-id="element-156">
          LOS 6 TOMOS EN DETALLE
        </h2>

        <div className="space-y-12" data-id="element-157">
          {/* TOMO 1 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-159"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-160">
              <span className="text-4xl" data-id="element-161">📘</span> TOMO 1 — Fundamentos y
              Química del Sabor
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-162">
              La base que todo lo demás necesita. Lo que ningún video de YouTube
              te explica completo.
            </p>
            <p className="text-stone-700 mb-6" data-id="element-163">
              Si saltás este tomo y vas directo a las recetas, vas a obtener
              resultados inconsistentes para siempre. Si lo leés primero, todo
              lo demás tiene sentido.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-164">
              <li className="flex gap-3" data-id="element-165">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-166" />
                <span data-id="element-167">
                  <strong data-id="element-168">La ciencia del curado:</strong> Por qué la sal y los
                  nitritos hacen lo que hacen y qué pasa exactamente si te
                  equivocás en la dosis
                </span>
              </li>
              <li className="flex gap-3" data-id="element-169">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-170" />
                <span data-id="element-171">
                  <strong data-id="element-172">Las bacterias que trabajan para vos:</strong>{' '}
                  Fermentación láctica, pH y por qué el salame artesanal bien
                  hecho es seguro
                </span>
              </li>
              <li className="flex gap-3" data-id="element-173">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-174" />
                <span data-id="element-175">
                  <strong data-id="element-176">La sal de cura #1 y #2:</strong> Cuál se usa en cada
                  producto y por qué NO son intercambiables bajo ninguna
                  circunstancia
                </span>
              </li>
              <li className="flex gap-3" data-id="element-177">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-178" />
                <span data-id="element-179">
                  <strong data-id="element-180">El secadero casero:</strong> Cómo convertir una
                  heladera vieja en una cámara de curado profesional por menos
                  de lo que cuesta una cena afuera
                </span>
              </li>
              <li className="flex gap-3" data-id="element-181">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-182" />
                <span data-id="element-183">
                  <strong data-id="element-184">Temperatura, humedad y tiempo:</strong> Los tres
                  parámetros que determinan si tu producto queda bien o va a la
                  basura
                </span>
              </li>
              <li className="flex gap-3" data-id="element-185">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-186" />
                <span data-id="element-187">
                  <strong data-id="element-188">El equipamiento mínimo real:</strong> Qué necesitás de
                  verdad y qué es marketing innecesario
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-189">
              Después de este tomo nunca más vas a picar carne caliente ni vas a
              agregarle la sal de cura al final.
            </p>
          </div>

          {/* TOMO 2 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-190">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-191"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-192">
              <span className="text-4xl" data-id="element-193">📗</span> TOMO 2 — Salames y Embutidos
              Secos
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-194">
              El producto más buscado. El más difícil de encontrar bien
              explicado en Argentina.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-195">
              <li className="flex gap-3" data-id="element-196">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-197" />
                <span data-id="element-198">
                  <strong data-id="element-199">Selección de carnes y grasas:</strong> Qué cortes
                  comprar, en qué carnicería pedir y qué decirle al carnicero
                  exactamente
                </span>
              </li>
              <li className="flex gap-3" data-id="element-200">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-201" />
                <span data-id="element-202">
                  <strong data-id="element-203">El ratio 70/30 y sus variantes:</strong> Por qué la
                  proporción de grasa determina la textura final y cómo
                  ajustarla
                </span>
              </li>
              <li className="flex gap-3" data-id="element-204">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-205" />
                <span data-id="element-206">
                  <strong data-id="element-207">El picado correcto:</strong> Temperatura,
                  granulometría y por qué el orden en que agregás los
                  ingredientes importa
                </span>
              </li>
              <li className="flex gap-3" data-id="element-208">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-209" />
                <span data-id="element-210">
                  <strong data-id="element-211">El amasado que activa la proteína:</strong> La
                  diferencia entre un salame que se corta limpio y uno que se
                  desmiga
                </span>
              </li>
              <li className="flex gap-3" data-id="element-212">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-213" />
                <span data-id="element-214">
                  <strong data-id="element-215">Estufado y fermentación:</strong> Las 48 horas que
                  definen todo el curado posterior y cómo controlarlas
                </span>
              </li>
              <li className="flex gap-3" data-id="element-216">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-217" />
                <span data-id="element-218">
                  <strong data-id="element-219">Recetas completas con dosis exactas:</strong> Salame
                  Mercedino, Salame Tandilero, Salame tipo Milán y Fuet
                  artesanal
                </span>
              </li>
              <li className="flex gap-3" data-id="element-220">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-221" />
                <span data-id="element-222">
                  <strong data-id="element-223">El calendario de control semana a semana:</strong> Qué
                  verificar, qué pérdida de peso esperar y cuándo preocuparse
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-224">
              El salame que siempre quisiste hacer. Con el proceso que nunca te
              explicaron completo.
            </p>
          </div>

          {/* TOMO 3 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-225">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-226"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-227">
              <span className="text-4xl" data-id="element-228">📙</span> TOMO 3 — Piezas Enteras
              Curadas
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-229">
              Bondiola, jamón, panceta y lomo. Los productos que más impresionan
              en una tabla.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-230">
              <li className="flex gap-3" data-id="element-231">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-232" />
                <span data-id="element-233">
                  <strong data-id="element-234">Curado en cajón vs. curado al vacío:</strong> Cuándo
                  usar cada método y qué diferencia concreta da en el resultado
                </span>
              </li>
              <li className="flex gap-3" data-id="element-235">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-236" />
                <span data-id="element-237">
                  <strong data-id="element-238">Las dosis exactas para cada pieza:</strong> Con tabla
                  de referencia por peso para que nunca tengas que calcular de
                  cabeza
                </span>
              </li>
              <li className="flex gap-3" data-id="element-239">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-240" />
                <span data-id="element-241">
                  <strong data-id="element-242">El atado profesional:</strong> Cómo envolver y atar
                  una bondiola o una panceta para que quede perfecta al corte
                </span>
              </li>
              <li className="flex gap-3" data-id="element-243">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-244" />
                <span data-id="element-245">
                  <strong data-id="element-246">El lavado post-curado:</strong> El paso que el 80% de
                  los principiantes saltea y que cambia completamente el
                  resultado
                </span>
              </li>
              <li className="flex gap-3" data-id="element-247">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-248" />
                <span data-id="element-249">
                  <strong data-id="element-250">El calendario de secado semana a semana:</strong>{' '}
                  Pérdida de peso esperada, señales de alerta y cuándo está
                  listo
                </span>
              </li>
              <li className="flex gap-3" data-id="element-251">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-252" />
                <span data-id="element-253">
                  <strong data-id="element-254">El jamón crudo:</strong> El producto más largo y más
                  complejo de toda la charcutería. Con el protocolo completo
                  para hacerlo en casa sin misterios
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-255">
              Cuando cortés tu primera bondiola y veas ese color rosado uniforme
              de borde a borde, vas a entender por qué vale la pena.
            </p>
          </div>

          {/* TOMO 4 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-256">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-257"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-258">
              <span className="text-4xl" data-id="element-259">📔</span> TOMO 4 — Chacinados Frescos y
              Parrilleros
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-260">
              El chorizo argentino en todas sus versiones. El producto que más
              comemos y que menos sabemos hacer bien.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-261">
              <li className="flex gap-3" data-id="element-262">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-263" />
                <span data-id="element-264">
                  <strong data-id="element-265">El chorizo parrillero clásico:</strong> La receta que
                  funciona, el ratio de grasa correcto y las variantes
                  regionales que no conocías
                </span>
              </li>
              <li className="flex gap-3" data-id="element-266">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-267" />
                <span data-id="element-268">
                  <strong data-id="element-269">El chorizo norteño:</strong> Comino tostado, ají y la
                  identidad del norte en un embutido
                </span>
              </li>
              <li className="flex gap-3" data-id="element-270">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-271" />
                <span data-id="element-272">
                  <strong data-id="element-273">El chorizo colorado:</strong> Pimentón, técnica y el
                  secreto del color intenso que no se va con el calor
                </span>
              </li>
              <li className="flex gap-3" data-id="element-274">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-275" />
                <span data-id="element-276">
                  <strong data-id="element-277">La morcilla artesanal:</strong> El producto más
                  subestimado de la charcutería argentina. Con el protocolo de
                  sangre segura y la versión vasca
                </span>
              </li>
              <li className="flex gap-3" data-id="element-278">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-279" />
                <span data-id="element-280">
                  <strong data-id="element-281">La salchicha parrillera:</strong> La ligazón que hace
                  la diferencia entre la que explota en la parrilla y la que no
                </span>
              </li>
              <li className="flex gap-3" data-id="element-282">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-283" />
                <span data-id="element-284">
                  <strong data-id="element-285">Conservación y vida útil real:</strong> Cómo
                  almacenar, cómo congelar y cuánto dura realmente cada producto
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-286">
              El chorizo que hacés una vez y nunca más comprás en el súper.
            </p>
          </div>

          {/* TOMO 5 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-287">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-288"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-289">
              <span className="text-4xl" data-id="element-290">📒</span> TOMO 5 — Charcutería de
              Especialidad
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-291">
              Leberwurst, patés, terrinas y galantinas. Lo que separa al
              charcutero artesanal del maestro.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-292">
              <li className="flex gap-3" data-id="element-293">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-294" />
                <span data-id="element-295">
                  <strong data-id="element-296">La emulsión:</strong> El principio técnico detrás del
                  leberwurst y la mortadela. Por qué la temperatura lo es todo y
                  qué pasa si se rompe
                </span>
              </li>
              <li className="flex gap-3" data-id="element-297">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-298" />
                <span data-id="element-299">
                  <strong data-id="element-300">El Leberwurst artesanal:</strong> Receta completa con
                  el protocolo de preparación del hígado que elimina el amargor
                </span>
              </li>
              <li className="flex gap-3" data-id="element-301">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-302" />
                <span data-id="element-303">
                  <strong data-id="element-304">El Paté de Campo:</strong> Textura rústica, dos
                  granulometrías y el prensado post-cocción que hace toda la
                  diferencia
                </span>
              </li>
              <li className="flex gap-3" data-id="element-305">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-306" />
                <span data-id="element-307">
                  <strong data-id="element-308">La Terrina Gourmet:</strong> El producto más visual de
                  la charcutería. El diseño interior que impresiona al corte
                </span>
              </li>
              <li className="flex gap-3" data-id="element-309">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-310" />
                <span data-id="element-311">
                  <strong data-id="element-312">La Galantina de Ave:</strong> El deshuesado completo
                  del pollo, la farsa de relleno y la cocción perfecta
                </span>
              </li>
              <li className="flex gap-3" data-id="element-313">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-314" />
                <span data-id="element-315">
                  <strong data-id="element-316">El Queso de Cerdo:</strong> Cero desperdicio. La
                  cabeza del cerdo transformada en el producto que más sorprende
                  a quien lo prueba por primera vez
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-317">
              Los productos que se venden a $55.000 el kilo en las charcuterías
              boutique. Que ahora podés hacer vos.
            </p>
          </div>

          {/* TOMO 6 */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-stone-200 relative overflow-hidden" data-id="element-318">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-700" data-id="element-319"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4 flex items-center gap-3" data-id="element-320">
              <span className="text-4xl" data-id="element-321">📓</span> TOMO 6 — El Manual del
              Maestro Curador
            </h3>
            <p className="text-lg text-stone-600 italic mb-6" data-id="element-322">
              El sistema operativo del charcutero artesanal serio. Todo lo que
              no está en las recetas pero que determina si los resultados son
              consistentes.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-323">
              <li className="flex gap-3" data-id="element-324">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-325" />
                <span data-id="element-326">
                  <strong data-id="element-327">El secadero profesional paso a paso:</strong>{' '}
                  Materiales, controladores, higrómetros y el sistema de
                  colgado. Todo
                </span>
              </li>
              <li className="flex gap-3" data-id="element-328">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-329" />
                <span data-id="element-330">
                  <strong data-id="element-331">Control de temperatura y humedad:</strong> Cómo
                  automatizarlo con menos de $100.000 ARS en equipamiento
                  accesible
                </span>
              </li>
              <li className="flex gap-3" data-id="element-332">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-333" />
                <span data-id="element-334">
                  <strong data-id="element-335">La prevención de hongos y ácaros:</strong> Los cuatro
                  tipos de moho, cómo identificarlos y qué hacer exactamente con
                  cada uno
                </span>
              </li>
              <li className="flex gap-3" data-id="element-336">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-337" />
                <span data-id="element-338">
                  <strong data-id="element-339">El sistema de producción escalonada:</strong> Cómo
                  tener siempre productos en distintas etapas listos para
                  consumir o vender
                </span>
              </li>
              <li className="flex gap-3" data-id="element-340">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-341" />
                <span data-id="element-342">
                  <strong data-id="element-343">El cuaderno de producción:</strong> El registro que
                  convierte cada lote en aprendizaje acumulado y resultados cada
                  vez más predecibles
                </span>
              </li>
              <li className="flex gap-3" data-id="element-344">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-1" data-id="element-345" />
                <span data-id="element-346">
                  <strong data-id="element-347">Cómo escalar el negocio artesanal:</strong> Del
                  consumo propio a los primeros clientes. El plan real de cuatro
                  etapas
                </span>
              </li>
            </ul>
            <p className="font-bold text-stone-900 bg-stone-100 p-4 rounded-lg" data-id="element-348">
              El tomo que convierte una afición en un sistema que funciona solo.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-349">
          <button onClick={handleScrollToCompra} className="bg-red-700 hover:bg-red-800 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-[0_8px_30px_rgb(185,28,28,0.3)] hover:shadow-[0_8px_30px_rgb(185,28,28,0.5)] transform hover:-translate-y-1 transition-all flex items-center justify-center gap-3 mx-auto w-full md:w-auto" data-id="element-350">
            SÍ, QUIERO DEJAR DE IMPROVISAR <ArrowRight className="w-6 h-6" data-id="element-351" />
          </button>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="bg-stone-900 text-stone-100 py-20 px-4 md:px-8" data-id="element-352">
        <div className="max-w-5xl mx-auto" data-id="element-353">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-center mb-4 text-white" data-id="element-354">
            MÁS 12 BONOS INCLUIDOS
          </h2>
          <p className="text-xl text-red-400 text-center font-bold mb-16 uppercase tracking-wider" data-id="element-355">
            SIN COSTO ADICIONAL
          </p>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-356">
            {/* Bono 1 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-357">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-358">
                <img src="https://cdn.magicpatterns.com/uploads/oKVFAgsFdssE6ewuSNt3rp/bono_1_charcuteria.png" alt="Bono #1 — Calculadora de Sal y Nitritos" className="w-full h-64 object-contain" data-id="element-359" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-360">
                <Gift className="w-5 h-5" data-id="element-361" /> BONO #1 — Calculadora de Sal y
                Nitritos
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-362">
                Tablas listas para 9 productos diferentes. Desde 0.6 kg hasta 12
                kg.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-363">
                Las dosis exactas de sal, sal de cura, dextrosa y especias para
                cada producto según el peso de tu elaboración. Con verificación
                de nitritos para confirmar que estás dentro del límite seguro.
                La hoja de trabajo que completás el día de producción sin buscar
                nada, sin calcular nada y sin dudar de nada.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-364">
                Nunca más calculás de cabeza ni usás el ojo para dosificar la
                sal de cura.
              </p>
            </div>

            {/* Bono 2 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-365">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-366">
                <img src="https://cdn.magicpatterns.com/uploads/tFsP92xRGK5awew33AHx3L/bono_2_charbuteria.png" alt="Bono #2 — Guía de Compra de Tripas" className="w-full h-64 object-contain" data-id="element-367" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-368">
                <Gift className="w-5 h-5" data-id="element-369" /> BONO #2 — Guía de Compra de Tripas
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-370">
                Natural vs. colágeno. Calibres, usos, hidratación y dónde
                conseguirlas en Argentina.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-371">
                La guía completa de todas las tripas disponibles en el mercado
                argentino. Con la tabla de decisión rápida que te dice qué tripa
                usar para cada producto en 10 segundos. Incluye el protocolo de
                hidratación, el almacenamiento correcto y los defectos más
                comunes con sus soluciones exactas.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-372">
                Nunca más comprás la tripa equivocada ni la rompés durante el
                embutido.
              </p>
            </div>

            {/* Bono 3 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-373">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-374">
                <img src="https://cdn.magicpatterns.com/uploads/rVqU4CWpU2daJ6f9RJcnsG/bono_3_charcuteria.png" alt="Bono #3 — El Mapa del Carnicero" className="w-full h-64 object-contain" data-id="element-375" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-376">
                <Gift className="w-5 h-5" data-id="element-377" /> BONO #3 — El Mapa del Carnicero
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-378">
                Cortes argentinos para charcutería. Qué pedir, cómo pedirlo y
                cuánto pagar.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-379">
                El mapa completo de los cortes de cerdo y vacuno para
                charcutería artesanal argentina. Con el vocabulario exacto para
                usar en la carnicería, la tabla de rendimiento real por corte y
                las listas de compras pre-armadas para los productos más
                comunes.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-380">
                Entrás a la carnicería sabiendo exactamente qué pedir y qué
                precio es razonable.
              </p>
            </div>

            {/* Bono 4 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-381">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-382">
                <img src="https://cdn.magicpatterns.com/uploads/2ofPHMRxrpvUQAeJHwtisc/bono_4_charcuteria.png" alt="Bono #4 — Ahumado en Frío y Calor" className="w-full h-64 object-contain" data-id="element-383" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-384">
                <Gift className="w-5 h-5" data-id="element-385" /> BONO #4 — Ahumado en Frío y Calor
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-386">
                Las maderas, los tiempos, los protocolos. El ahumado artesanal
                que diferencia tu producto.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-387">
                Manzano, cerezo, quebracho blanco y algarrobo: los perfiles
                aromáticos de cada madera y cuándo usar cada una. Los protocolos
                completos de ahumado en frío para salame y bondiola. El ahumado
                en caliente para panceta y chorizo. Cómo construir tu ahumador
                con una heladera vieja o un tambor de 200 litros.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-388">
                El salame levemente ahumado en manzano que hace que todo el
                mundo pregunte qué tiene de diferente.
              </p>
            </div>

            {/* Bono 5 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-389">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-390">
                <img src="https://cdn.magicpatterns.com/uploads/vX3poi6463bciypM8NGFsJ/bono_5_charcuteria.png" alt="Bono #5 — Escabeches y Guarniciones" className="w-full h-64 object-contain" data-id="element-391" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-392">
                <Gift className="w-5 h-5" data-id="element-393" /> BONO #5 — Escabeches y Guarniciones
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-394">
                9 recetas completas. Berenjenas, morrones, pickles, aceitunas y
                más.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-395">
                Las guarniciones que completan la tabla artesanal y que tienen
                márgenes de ganancia extraordinarios. Con los protocolos de
                conservación correctos, los tiempos de vida útil reales y la
                guía de maridaje que te dice qué guarnición va con cada embutido
                para lograr el equilibrio perfecto en la tabla.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-396">
                Porque la picada perfecta no termina en los embutidos.
              </p>
            </div>

            {/* Bono 6 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-397">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-398">
                <img src="https://cdn.magicpatterns.com/uploads/qGu16xnjExwCnufkQoYgyt/bono_6_charcuteria.png" alt="Bono #6 — Mezcla de Especias De Autor" className="w-full h-64 object-contain" data-id="element-399" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-400">
                <Gift className="w-5 h-5" data-id="element-401" /> BONO #6 — Mezcla de Especias De
                Autor
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-402">
                15 mezclas completas diseñadas para charcutería artesanal
                argentina.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-403">
                Desde el Clásico Argentino hasta La Firma del Maestro. Con los
                fundamentos científicos que explican por qué cada especia va
                donde va, en qué momento del proceso se incorpora y cómo
                interactúa con la carne durante el curado. Incluye el proceso de
                cuatro pasos para crear tu propia mezcla de autor.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-404">
                Tu firma. Lo que nadie puede copiarte.
              </p>
            </div>

            {/* Bono 7 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-405">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-406">
                <img src="https://cdn.magicpatterns.com/uploads/1EpYXS8Wo9Gibc4DQbbC9H/bono_7_charcuteria.png" alt="Bono #7 — Protocolo de Rescate" className="w-full h-64 object-contain" data-id="element-407" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-408">
                <Gift className="w-5 h-5" data-id="element-409" /> BONO #7 — Protocolo de Rescate
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-410">
                7 protocolos para los problemas más comunes. El bono que más
                plata te va a ahorrar.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-411">
                El sistema completo de diagnóstico y rescate para los problemas
                del secadero. Tablas de diagnóstico por color y por olor. El
                test de la aguja para piezas enteras. Los 7 protocolos de
                rescate para moho superficial, costado seco, fermentación
                fallida, rancidez y más. Y las señales de descarte inmediato que
                no admiten dudas ni intentos de rescate.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-412">
                Dejá de tirar lotes que se pueden salvar. Y aprendé a reconocer
                cuándo realmente hay que descartar.
              </p>
            </div>

            {/* Bono 8 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-413">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-414">
                <img src="https://cdn.magicpatterns.com/uploads/eV3z7u4DJZfLXPTJQqaxQQ/bono_8_charcuteria.png" alt="Bono #8 — Charcutería Express" className="w-full h-64 object-contain" data-id="element-415" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-416">
                <Gift className="w-5 h-5" data-id="element-417" /> BONO #8 — Charcutería Express
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-418">
                8 productos listos en 24 a 72 horas. Sin secadero, sin esperas.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-419">
                Rillettes de cerdo, rillettes de pato, gravlax de salmón, lardo
                curado en 48 horas, paté de hígado express, panceta al vacío en
                36 horas y cecina de vacuno en 72 horas. Con el plan de
                producción de 5 días para tener una tabla completa lista para el
                fin de semana sin haber esperado un mes.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-420">
                La charcutería que impresiona esta semana, no dentro de 45 días.
              </p>
            </div>

            {/* Bono 9 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-421">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-422">
                <img src="https://cdn.magicpatterns.com/uploads/sgTFohTyNkaBSQ7Gva3s1Y/bono_9_charcuteria.png" alt="Bono #9 — Maridaje y Degustación" className="w-full h-64 object-contain" data-id="element-423" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-424">
                <Gift className="w-5 h-5" data-id="element-425" /> BONO #9 — Maridaje y Degustación
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-426">
                La temperatura correcta, el corte correcto, el vino correcto. El
                arte de servir.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-427">
                La guía completa de temperatura de servicio por producto. La
                tabla de grosor de corte óptimo para cada embutido. El maridaje
                con vinos argentinos, cervezas artesanales y bebidas sin
                alcohol. Las plantillas de tablas para distintas ocasiones. Y
                cómo fotografiar tu tabla para Instagram con el teléfono que ya
                tenés.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-428">
                El mismo producto servido correctamente vale el doble.
              </p>
            </div>

            {/* Bono 10 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-429">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-430">
                <img src="https://cdn.magicpatterns.com/uploads/kkFc97Rxj8vzz2hvGHb3up/bono_10_carcuteria.png" alt="Bono #10 — Guía de Costos y Rentabilidad" className="w-full h-64 object-contain" data-id="element-431" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-432">
                <Gift className="w-5 h-5" data-id="element-433" /> BONO #10 — Guía de Costos y
                Rentabilidad
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-434">
                Cuánto te cuesta realmente cada producto y cuánto tenés que
                cobrar.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-435">
                El sistema completo de gestión de costos con los cuatro
                componentes del costo real, incluyendo tu tiempo que es el más
                ignorado. La fórmula de precio correcto. El punto de equilibrio
                mensual. Los tres registros simples que necesitás para gestionar
                el negocio. Y la proyección de ingresos a 12 meses para el que
                quiere convertir esto en algo más que una afición.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-436">
                Hacé charcutería artesanal que se paga sola. Y que te paga a
                vos.
              </p>
            </div>

            {/* Bono 11 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-437">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-438">
                <img src="https://cdn.magicpatterns.com/uploads/bLgtWYAhMqPb32d7TQQ6Wx/bono_11_charcuteria.png" alt="Bono #11 — Checklist de Sanidad" className="w-full h-64 object-contain" data-id="element-439" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-440">
                <Gift className="w-5 h-5" data-id="element-441" /> BONO #11 — Checklist de Sanidad
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-442">
                Los patógenos, los protocolos, los checklists. Para elaborar con
                seguridad real.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-443">
                Los cinco patógenos más relevantes en charcutería y cómo
                prevenirlos específicamente. Los protocolos de limpieza y
                desinfección para cada superficie y equipo. La cadena de frío y
                la zona de peligro de temperatura. Los seis checklists completos
                para apertura, elaboración, cierre y mantenimiento del secadero.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-444">
                Producís con la misma seguridad que una charcutería profesional
                habilitada.
              </p>
            </div>

            {/* Bono 12 */}
            <div className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-445">
              <div className="bg-black rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-446">
                <img src="https://cdn.magicpatterns.com/uploads/e5s1SMhWPofFpqzeFXD5Qf/bono_12_charcuteria.png" alt="Bono #12 — Packaging de Boutique" className="w-full h-64 object-contain" data-id="element-447" />
              </div>
              <h4 className="text-xl font-bold text-red-400 mb-2 flex items-center gap-2" data-id="element-448">
                <Gift className="w-5 h-5" data-id="element-449" /> BONO #12 — Packaging de Boutique
              </h4>
              <p className="font-medium mb-3 text-stone-300" data-id="element-450">
                Cómo presentar tu charcutería para que el precio que cobrás sea
                bienvenido.
              </p>
              <p className="text-stone-400 text-sm mb-3" data-id="element-451">
                Los materiales de packaging artesanal y dónde conseguirlos en
                Argentina. Las técnicas de envuelto en papel manteca. Cómo armar
                frascos de paté y rillettes que parecen de charcutería boutique.
                La construcción de la tabla de regalo premium. Y la fotografía
                de producto para Instagram con el teléfono que ya tenés.
              </p>
              <p className="text-sm font-bold text-stone-200 italic" data-id="element-452">
                El mismo salame en papel manteca con hilo sisal y etiqueta
                artesanal vale tres veces más.
              </p>
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-453">
            <button onClick={handleScrollToCompra} className="bg-red-700 hover:bg-red-600 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-lg transform hover:-translate-y-1 transition-all flex items-center justify-center gap-3 mx-auto w-full md:w-auto" data-id="element-454">
              EMPEZAR AHORA CON DESCARGA INMEDIATA{' '}
              <ArrowRight className="w-6 h-6" data-id="element-455" />
            </button>
          </div>
        </div>
      </section>

      {/* TARGET AUDIENCE SECTION */}
      <section className="py-20 px-4 md:px-8 bg-stone-200" data-id="element-456">
        <div className="max-w-4xl mx-auto" data-id="element-457">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-10 text-center" data-id="element-458">
            ESTE SISTEMA ES PARA VOS SI…
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-md space-y-6" data-id="element-459">
            <div className="flex items-start gap-4" data-id="element-460">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-461">
                <Check className="w-5 h-5 text-green-700" data-id="element-462" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-463">
                Te apasiona la cocina y querés hacer charcutería artesanal de
                verdad, no solo seguir recetas de YouTube que a veces funcionan
                y a veces no
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-464">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-465">
                <Check className="w-5 h-5 text-green-700" data-id="element-466" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-467">
                Nunca hiciste charcutería pero querés empezar bien desde el
                primer intento sin desperdiciar carne cara aprendiendo a los
                golpes
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-468">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-469">
                <Check className="w-5 h-5 text-green-700" data-id="element-470" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-471">
                Ya intentaste hacer salame, chorizo o bondiola y algo salió mal
                y no entendiste exactamente qué ni en qué paso
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-472">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-473">
                <Check className="w-5 h-5 text-green-700" data-id="element-474" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-475">
                Encontrás información pero toda es de España o Italia y los
                cortes, los ingredientes y los nombres no aplican al mercado
                argentino
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-476">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-477">
                <Check className="w-5 h-5 text-green-700" data-id="element-478" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-479">
                Querés hacer productos que impresionen en el asado, en la tabla
                del domingo o en una cena con amigos
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-480">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-481">
                <Check className="w-5 h-5 text-green-700" data-id="element-482" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-483">
                Tenés amigos o familia que ya te dijeron "yo te compraría" y
                querés saber si esto puede convertirse en algo más que una
                afición
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-484">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-485">
                <Check className="w-5 h-5 text-green-700" data-id="element-486" />
              </div>
              <p className="text-lg text-stone-800" data-id="element-487">
                Querés un sistema que te diga exactamente qué hacer paso a paso
                sin tener que juntar información de diez fuentes diferentes que
                se contradicen
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-488">
              <div className="bg-green-100 p-1 rounded-full mt-1 shrink-0" data-id="element-489">
                <Check className="w-5 h-5 text-green-700" data-id="element-490" />
              </div>
              <p className="text-lg text-stone-800 font-bold" data-id="element-491">
                Sos el tipo de persona que cuando se mete en algo, se mete en
                serio y quiere hacerlo bien de verdad
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 md:px-8 max-w-6xl mx-auto" data-id="element-492">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-stone-900 mb-16" data-id="element-493">
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-494">
          {/* Testimonial 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col" data-id="element-495">
            <div className="flex text-yellow-400 mb-4" data-id="element-496">
              <Star className="w-5 h-5 fill-current" data-id="element-497" />
              <Star className="w-5 h-5 fill-current" data-id="element-498" />
              <Star className="w-5 h-5 fill-current" data-id="element-499" />
              <Star className="w-5 h-5 fill-current" data-id="element-500" />
              <Star className="w-5 h-5 fill-current" data-id="element-501" />
            </div>
            <p className="text-stone-700 italic mb-6 flex-grow" data-id="element-502">
              "Había intentado hacer salame tres veces siguiendo videos de
              YouTube. Las tres veces algo salió mal. La primera vez que seguí
              el sistema de la enciclopedia me quedó perfecto. No fue suerte:
              fue que por primera vez entendí qué estaba haciendo y por qué. El
              Salame Mercedino me salió un espectáculo."
            </p>
            <div className="border-t border-stone-100 pt-4" data-id="element-503">
              <p className="font-bold text-stone-900" data-id="element-504">Martín D.</p>
              <p className="text-sm text-stone-500 flex items-center gap-1" data-id="element-505">
                <MapPin className="w-3 h-3" data-id="element-506" /> Rosario, Santa Fe
              </p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col" data-id="element-507">
            <div className="flex text-yellow-400 mb-4" data-id="element-508">
              <Star className="w-5 h-5 fill-current" data-id="element-509" />
              <Star className="w-5 h-5 fill-current" data-id="element-510" />
              <Star className="w-5 h-5 fill-current" data-id="element-511" />
              <Star className="w-5 h-5 fill-current" data-id="element-512" />
              <Star className="w-5 h-5 fill-current" data-id="element-513" />
            </div>
            <p className="text-stone-700 italic mb-6 flex-grow" data-id="element-514">
              "Lo compré un sábado a la tarde. El domingo ya tenía mi primera
              bondiola en el secadero con las dosis exactas calculadas con el
              Bono de la calculadora. Tres semanas después la corté y quedó
              exactamente como la de la charcutería de mis abuelos. Me
              emocioné."
            </p>
            <div className="border-t border-stone-100 pt-4" data-id="element-515">
              <p className="font-bold text-stone-900" data-id="element-516">Carlos B.</p>
              <p className="text-sm text-stone-500 flex items-center gap-1" data-id="element-517">
                <MapPin className="w-3 h-3" data-id="element-518" /> Mar del Plata, Buenos Aires
              </p>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col" data-id="element-519">
            <div className="flex text-yellow-400 mb-4" data-id="element-520">
              <Star className="w-5 h-5 fill-current" data-id="element-521" />
              <Star className="w-5 h-5 fill-current" data-id="element-522" />
              <Star className="w-5 h-5 fill-current" data-id="element-523" />
              <Star className="w-5 h-5 fill-current" data-id="element-524" />
              <Star className="w-5 h-5 fill-current" data-id="element-525" />
            </div>
            <p className="text-stone-700 italic mb-6 flex-grow" data-id="element-526">
              "El Tomo 6 sobre el secadero me cambió todo. Tenía una heladera
              vieja en el quincho que no sabía qué hacer con ella. Ahora es mi
              cámara de curado. Por menos de $80.000 pesos armé algo que
              funciona igual que las cámaras que venden a $2.000.000. Ya tengo
              tres lomos curándose."
            </p>
            <div className="border-t border-stone-100 pt-4" data-id="element-527">
              <p className="font-bold text-stone-900" data-id="element-528">Roberto A.</p>
              <p className="text-sm text-stone-500 flex items-center gap-1" data-id="element-529">
                <MapPin className="w-3 h-3" data-id="element-530" /> Córdoba Capital
              </p>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col" data-id="element-531">
            <div className="flex text-yellow-400 mb-4" data-id="element-532">
              <Star className="w-5 h-5 fill-current" data-id="element-533" />
              <Star className="w-5 h-5 fill-current" data-id="element-534" />
              <Star className="w-5 h-5 fill-current" data-id="element-535" />
              <Star className="w-5 h-5 fill-current" data-id="element-536" />
              <Star className="w-5 h-5 fill-current" data-id="element-537" />
            </div>
            <p className="text-stone-700 italic mb-6 flex-grow" data-id="element-538">
              "Empecé comprando solo para hacer chorizos para el asado del
              domingo con los muchachos. Terminé haciendo rillettes, terrina
              gourmet y unas tablas de regalo que ahora me piden para comprarme.
              La enciclopedia se pagó sola en el primer mes."
            </p>
            <div className="border-t border-stone-100 pt-4" data-id="element-539">
              <p className="font-bold text-stone-900" data-id="element-540">Luciano M.</p>
              <p className="text-sm text-stone-500 flex items-center gap-1" data-id="element-541">
                <MapPin className="w-3 h-3" data-id="element-542" /> Mendoza
              </p>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-white p-8 rounded-2xl shadow-md border border-stone-200 flex flex-col md:col-span-2 lg:col-span-1" data-id="element-543">
            <div className="flex text-yellow-400 mb-4" data-id="element-544">
              <Star className="w-5 h-5 fill-current" data-id="element-545" />
              <Star className="w-5 h-5 fill-current" data-id="element-546" />
              <Star className="w-5 h-5 fill-current" data-id="element-547" />
              <Star className="w-5 h-5 fill-current" data-id="element-548" />
              <Star className="w-5 h-5 fill-current" data-id="element-549" />
            </div>
            <p className="text-stone-700 italic mb-6 flex-grow" data-id="element-550">
              "Lo que más me sorprendió fue el Bono de Protocolo de Rescate.
              Siempre tiraba todo a la basura cuando algo salía mal porque me
              daba miedo intoxicar a alguien. Ahora sé exactamente qué hacer con
              cada problema. Salvé dos tandas de panceta que antes iban directo
              a la basura."
            </p>
            <div className="border-t border-stone-100 pt-4" data-id="element-551">
              <p className="font-bold text-stone-900" data-id="element-552">Diego F.</p>
              <p className="text-sm text-stone-500 flex items-center gap-1" data-id="element-553">
                <MapPin className="w-3 h-3" data-id="element-554" /> Tandil, Buenos Aires
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="compra" className="py-20 px-4 md:px-8 bg-stone-50" data-id="element-555">
        <div className="max-w-3xl mx-auto" data-id="element-556">
          <div className="text-center mb-10" data-id="element-557">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-stone-900 mb-3" data-id="element-558">
              ELEGÍ TU <span className="text-red-700" data-id="element-559">PACK CHARCUTERÍA</span>
            </h2>
            <p className="text-lg text-stone-600" data-id="element-560">
              Todas las opciones incluyen los 12 bonos GRATIS + garantía de 7
              días.
            </p>
          </div>

          {/* SELECTABLE PACKS */}
          <div className="space-y-4 mb-6" data-id="element-561">
            {/* PACK ESENCIAL */}
            <button type="button" onClick={() => setSelectedPack('esencial')} className={`w-full text-left bg-stone-900 rounded-2xl p-5 md:p-6 border-2 transition-all ${selectedPack === 'esencial' ? 'border-red-600 shadow-[0_0_20px_rgba(220,38,38,0.35)]' : 'border-stone-700 hover:border-stone-500'}`} data-id="element-562">
              <div className="flex items-center gap-4" data-id="element-563">
                {/* Radio */}
                <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center ${selectedPack === 'esencial' ? 'border-red-500' : 'border-stone-500'}`} data-id="element-564">
                  {selectedPack === 'esencial' && <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-565"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-566">
                  <div className="flex items-center gap-2 mb-1" data-id="element-567">
                    <span className="text-xl" data-id="element-568">🥩</span>
                    <h3 className="text-base md:text-xl font-bold text-white" data-id="element-569">
                      PACK ESENCIAL
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-stone-400" data-id="element-570">
                    Enciclopedia Charcutería + 12 Bonos
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0" data-id="element-571">
                  <p className="text-xs text-stone-500 line-through" data-id="element-572">$39.990</p>
                  <p className="text-xl md:text-3xl font-black text-white" data-id="element-573">
                    $15.990
                  </p>
                </div>
              </div>
            </button>

            {/* PACK PREMIUM */}
            <button type="button" onClick={() => setSelectedPack('premium')} className={`w-full text-left bg-stone-900 rounded-2xl p-5 md:p-6 border-2 transition-all relative ${selectedPack === 'premium' ? 'border-red-600 shadow-[0_0_20px_rgba(220,38,38,0.35)]' : 'border-stone-700 hover:border-stone-500'}`} data-id="element-574">
              <div className="flex items-center gap-4" data-id="element-575">
                {/* Radio */}
                <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center ${selectedPack === 'premium' ? 'border-red-500' : 'border-stone-500'}`} data-id="element-576">
                  {selectedPack === 'premium' && <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-577"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-578">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-579">
                    <span className="text-xl" data-id="element-580">🏆</span>
                    <h3 className="text-base md:text-xl font-bold text-white" data-id="element-581">
                      PACK PREMIUM
                    </h3>
                    <span className="bg-red-600 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-582">
                      <Star className="w-3 h-3 fill-current" data-id="element-583" /> MÁS ELEGIDO
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-stone-400" data-id="element-584">
                    Todo lo del Esencial + Jamón de Autor + Sistema Asado
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0" data-id="element-585">
                  <p className="text-xs text-stone-500 line-through" data-id="element-586">$59.990</p>
                  <p className="text-xl md:text-3xl font-black text-red-500" data-id="element-587">
                    $21.990
                  </p>
                </div>
              </div>
            </button>
          </div>

          {/* DYNAMIC CTA */}
          <a href={selectedPack === 'esencial' ? 'https://charcuteriacheck.librosdigitales.pro/cart/45463144136783:1' : 'https://charcuteriacheck.librosdigitales.pro/cart/45463160979535:1'} onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              content_name: selectedPack === 'premium' ? 'Pack Premium' : 'Pack Esencial',
              value: selectedPack === 'premium' ? 21990 : 15990,
              currency: 'ARS'
            });
          }
        }} className="block text-center bg-green-600 hover:bg-green-500 text-white text-lg md:text-2xl font-black py-5 px-6 rounded-xl shadow-[0_0_20px_rgba(22,163,74,0.4)] hover:shadow-[0_0_30px_rgba(22,163,74,0.6)] transform hover:-translate-y-1 transition-all uppercase tracking-wide mb-3" data-id="element-588">
            {selectedPack === 'premium' ? 'SÍ, QUIERO EL PACK PREMIUM →' : 'SÍ, QUIERO EL PACK ESENCIAL →'}
          </a>
          <p className="text-center text-sm text-stone-500 italic mb-8" data-id="element-589">
            Podés actualizar al Premium cuando quieras
          </p>

          {/* DETAILS BOX - Dynamic based on selection */}
          <div className="bg-white border-2 border-stone-200 rounded-2xl p-6 md:p-8" data-id="element-590">
            <p className="text-xs font-bold tracking-widest text-stone-500 uppercase mb-5" data-id="element-591">
              {selectedPack === 'premium' ? 'PACK PREMIUM INCLUYE:' : 'PACK ESENCIAL INCLUYE:'}
            </p>

            <div className="grid md:grid-cols-2 gap-x-6 gap-y-3 text-stone-800" data-id="element-592">
              <div className="flex gap-2" data-id="element-593">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-594" />
                <span className="text-sm md:text-base" data-id="element-595">
                  <strong data-id="element-596">Los 6 Tomos</strong> de la Enciclopedia (400+ págs)
                </span>
              </div>
              <div className="flex gap-2" data-id="element-597">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-598" />
                <span className="text-sm md:text-base" data-id="element-599">
                  <strong data-id="element-600">12 Bonos</strong> especializados GRATIS hoy
                </span>
              </div>
              <div className="flex gap-2" data-id="element-601">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-602" />
                <span className="text-sm md:text-base" data-id="element-603">
                  100+ recetas con dosis exactas
                </span>
              </div>
              <div className="flex gap-2" data-id="element-604">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-605" />
                <span className="text-sm md:text-base" data-id="element-606">
                  Calculadora de costos en Google Sheets
                </span>
              </div>
              <div className="flex gap-2" data-id="element-607">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-608" />
                <span className="text-sm md:text-base" data-id="element-609">
                  15 mezclas de especias imprimibles
                </span>
              </div>
              <div className="flex gap-2" data-id="element-610">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-611" />
                <span className="text-sm md:text-base" data-id="element-612">
                  Acceso de por vida + actualizaciones
                </span>
              </div>
              <div className="flex gap-2" data-id="element-613">
                <Check className="w-5 h-5 text-red-600 shrink-0 mt-0.5" data-id="element-614" />
                <span className="text-sm md:text-base" data-id="element-615">
                  Garantía de 7 días sin preguntas
                </span>
              </div>
            </div>

            {/* PREMIUM EXTRAS */}
            {selectedPack === 'premium' && <>
                <div className="mt-8 pt-6 border-t-2 border-dashed border-red-200" data-id="element-616">
                  <p className="text-xs font-bold tracking-widest text-red-700 uppercase mb-5 flex items-center gap-2" data-id="element-617">
                    <Star className="w-4 h-4 fill-current" data-id="element-618" /> EXTRAS EXCLUSIVOS
                    DEL PACK PREMIUM
                  </p>

                  <div className="space-y-4" data-id="element-619">
                    {/* JAMÓN DE AUTOR */}
                    <div className="bg-stone-50 border-l-4 border-red-700 p-4 rounded-r-lg" data-id="element-620">
                      <h4 className="font-bold text-stone-900 mb-1 flex items-center gap-2" data-id="element-621">
                        🥓 JAMÓN IBÉRICO ARGENTINO
                        <span className="text-xs text-red-700 font-bold" data-id="element-622">
                          ESTILO EUROPEO
                        </span>
                      </h4>
                      <p className="text-sm text-stone-700 mb-2" data-id="element-623">
                        Técnica tipo Ibérica adaptada a Argentina. El producto
                        cumbre de la charcutería mundial, hecho en casa.
                      </p>
                      <ul className="text-xs md:text-sm text-stone-600 space-y-1 mt-2" data-id="element-624">
                        <li data-id="element-625">
                          ✓ Selección de la pieza ideal (peso, grasa, piel)
                        </li>
                        <li data-id="element-626">✓ Protocolo de desangrado paso a paso</li>
                        <li data-id="element-627">✓ La fórmula exacta de salado (kg × 1.1)</li>
                        <li data-id="element-628">
                          ✓ Sudado de verano: el secreto de la grasa traslúcida
                        </li>
                        <li data-id="element-629">
                          ✓ Calendario de maduración mes a mes (14-18 meses)
                        </li>
                        <li data-id="element-630">✓ Cómo fabricar y usar la cala de hueso</li>
                        <li data-id="element-631">
                          ✓ Técnica de corte y servicio del jamón de autor
                        </li>
                        <li data-id="element-632">✓ 8 problemas más comunes y sus soluciones</li>
                      </ul>
                    </div>

                    {/* SISTEMA ASADO */}
                    <div className="bg-stone-50 border-l-4 border-red-700 p-4 rounded-r-lg" data-id="element-633">
                      <h4 className="font-bold text-stone-900 mb-1 flex items-center gap-2" data-id="element-634">
                        🔥 CÓDIGO ASADO: SISTEMA MAESTRO CENTENARIO
                        <span className="text-xs text-red-700 font-bold" data-id="element-635">
                          11 TOMOS
                        </span>
                      </h4>
                      <p className="text-sm text-stone-700 mb-2" data-id="element-636">
                        El sistema completo del asado argentino. Para que tu
                        picada de charcutería tenga el asado a la altura.
                      </p>
                      <ul className="text-xs md:text-sm text-stone-600 space-y-1 mt-2" data-id="element-637">
                        <li data-id="element-638">✓ Cómo no dejarte cagar en la carnicería</li>
                        <li data-id="element-639">
                          ✓ Asado de primera con bolsillo flaco (8 cortes
                          económicos)
                        </li>
                        <li data-id="element-640">
                          ✓ El corte correcto después de la cocción perfecta
                        </li>
                        <li data-id="element-641">
                          ✓ Dominar el fuego de una vez (método Cero Humo)
                        </li>
                        <li data-id="element-642">
                          ✓ Que todo llegue junto y en punto (cronogramas)
                        </li>
                        <li data-id="element-643">✓ La sal, el chimi y todo lo que va encima</li>
                        <li data-id="element-644">
                          ✓ Técnicas de campo (asado a la cruz, horno de barro,
                          entierro patagónico)
                        </li>
                        <li data-id="element-645">✓ 15 protocolos de rescate cuando algo sale mal</li>
                        <li data-id="element-646">
                          ✓ 4 bonos extra: El Ojo del Asador, La Libreta del
                          Parrillero, y más
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="mt-5 text-center bg-red-50 border border-red-200 rounded-lg p-3" data-id="element-647">
                    <p className="text-sm text-stone-700" data-id="element-648">
                      Valor real de los extras:{' '}
                      <span className="line-through text-stone-500" data-id="element-649">
                        $29.990
                      </span>{' '}
                      ·{' '}
                      <strong className="text-red-700" data-id="element-650">Hoy solo +$6.000</strong>
                    </p>
                  </div>
                </div>
              </>}
          </div>

          {/* TRUST BAR */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-stone-500" data-id="element-651">
            <span className="flex items-center gap-1" data-id="element-652">
              <Shield className="w-4 h-4" data-id="element-653" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-654">
              <Clock className="w-4 h-4" data-id="element-655" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-656">
              <Check className="w-4 h-4" data-id="element-657" /> Descarga en PDF
            </span>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 px-4 md:px-8 bg-stone-200 border-y border-stone-300" data-id="element-658">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8" data-id="element-659">
          <div className="bg-stone-900 p-6 rounded-full shrink-0" data-id="element-660">
            <Shield className="w-16 h-16 text-red-500" data-id="element-661" />
          </div>
          <div data-id="element-662">
            <h2 className="font-serif text-3xl font-bold text-stone-900 mb-4" data-id="element-663">
              GARANTÍA DE 7 DÍAS SIN PREGUNTAS
            </h2>
            <p className="text-lg text-stone-700 mb-4" data-id="element-664">
              Usalo una semana completa. Hacé tu primera elaboración con el
              sistema. Calculá tus primeras dosis con la calculadora. Armá tu
              secadero con el Tomo 6.
            </p>
            <p className="text-lg text-stone-700 mb-4" data-id="element-665">
              Si después de 7 días no llegás a cada elaboración con más
              claridad, más seguridad y resultados notablemente mejores que
              antes, te devolvemos el 100% del dinero.
            </p>
            <p className="text-lg font-bold text-stone-900" data-id="element-666">
              Sin preguntas. Sin formularios. Sin vueltas.
            </p>
            <p className="text-stone-600 italic mt-2" data-id="element-667">
              Confiamos en el sistema porque lo vimos funcionar. Ahora te toca a
              vos comprobarlo.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-668">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-669">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-6" data-id="element-670">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-671">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-672">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-673" /> ¿Necesito
              experiencia previa en charcutería?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-674">
              No. El Tomo 1 te da todos los fundamentos desde cero de forma
              clara y sin tecnicismos innecesarios. Si nunca hiciste nada,
              empezás por ahí. Si ya tenés algo de experiencia, vas a encontrar
              en cada tomo el nivel técnico que faltaba para que los resultados
              sean consistentes.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-675">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-676">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-677" /> ¿Los ingredientes
              y cortes son argentinos?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-678">
              Completamente. Los nombres de los cortes, los ingredientes con sus
              nombres argentinos, los proveedores sugeridos y los contextos
              están todos pensados para el mercado argentino. No vas a encontrar
              "coppa di testa" ni "lonza": vas a encontrar bondiola y lomo
              curado.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-679">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-680">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-681" /> ¿Necesito un
              secadero para empezar?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-682">
              No. Podés empezar con los productos del Tomo 4 (chorizo fresco,
              morcilla, salchicha parrillera) sin ningún equipamiento especial.
              El salame y las piezas curadas necesitan el secadero que el Tomo 6
              te enseña a construir con una heladera vieja. La mayoría de las
              personas empieza por los frescos mientras arma el secadero en
              paralelo.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-683">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-684">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-685" /> ¿Cuántas veces
              puedo imprimir?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-686">
              Las veces que necesités. Para todas tus elaboraciones. De por
              vida. No hay restricción de uso de ningún tipo.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-687">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-688">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-689" /> ¿Sirve si quiero
              empezar a vender?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-690">
              Sí. El Tomo 6 tiene un capítulo específico sobre cómo escalar de
              la producción doméstica a los primeros clientes. El Bono #10 te da
              el sistema completo de costos y precios para que sepas exactamente
              cuánto cobrar y cuándo el negocio es rentable.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-691">
            <h4 className="text-xl font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-692">
              <ChevronDown className="w-5 h-5 text-red-700" data-id="element-693" /> ¿Qué pasa si no
              es lo que esperaba?
            </h4>
            <p className="text-stone-700 pl-7" data-id="element-694">
              Tenés 7 días de garantía total. Si no cambia la forma en que
              elaborás, si no reducís el tiempo que perdés buscando información
              contradictoria en internet y si no obtenés resultados notablemente
              mejores, te devolvemos el 100% sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CLOSE */}
      <section className="bg-stone-900 text-center py-24 px-4 md:px-8 border-t-8 border-red-700" data-id="element-695">
        <div className="max-w-3xl mx-auto" data-id="element-696">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-697">
            Máster en Charcutería de Autor: <br data-id="element-698" />
            <span className="text-red-500" data-id="element-699">La Enciclopedia Argentina™</span>
          </h2>
          <p className="text-xl text-stone-300 mb-8 font-medium" data-id="element-700">
            Porque tu pasión por la charcutería artesanal merece un sistema
            completo.
          </p>
          <p className="text-lg text-stone-400 mb-10" data-id="element-701">
            No recetas sueltas de internet. No videos que se contradicen. No
            información de otro país que no aplica acá.
          </p>
          <p className="text-2xl font-bold text-white mb-12 tracking-widest uppercase" data-id="element-702">
            Un sistema. Argentino. Completo. Tuyo.
          </p>

          <div className="mb-8" data-id="element-703">
            <p className="text-4xl font-black text-white mb-2" data-id="element-704">$15.990 ARS</p>
            <p className="text-stone-400" data-id="element-705">
              Acceso inmediato · Garantía 7 días · Acceso de por vida
            </p>
          </div>

          <a href="Link de tu checkout" className="inline-flex bg-red-700 hover:bg-red-600 text-white text-2xl font-bold py-6 px-12 rounded-xl shadow-[0_0_30px_rgba(185,28,28,0.5)] hover:shadow-[0_0_40px_rgba(185,28,28,0.7)] transform hover:-translate-y-1 transition-all items-center justify-center gap-3 w-full md:w-auto mb-8" data-id="element-706">
            QUIERO EL SISTEMA AHORA <ArrowRight className="w-6 h-6" data-id="element-707" />
          </a>

          <div className="flex flex-col items-center gap-2 text-stone-400 text-sm" data-id="element-708">
            <p className="flex items-center gap-2" data-id="element-709">
              <Shield className="w-4 h-4" data-id="element-710" /> Pago seguro con Mercado Pago · Visa
              · Mastercard · American Express · Débito
            </p>
            <p data-id="element-711">
              Descarga inmediata después del pago · Sin suscripciones · Sin
              costos ocultos
            </p>
          </div>
        </div>
      </section>
    </div>;
}